/* eslint-disable @atlaskit/design-system/no-legacy-icons */
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import NewMentionIcon from '@atlaskit/icon/core/mention';
import OldMentionIcon from '@atlaskit/icon/glyph/mention';
import React from 'react';

const MentionIcon = (
  props: Omit<NewCoreIconProps, 'spacing' | 'LEGACY_size' | 'LEGACY_fallbackIcon'>
) => {
  return (
    <NewMentionIcon
      spacing="spacious"
      LEGACY_size="small"
      LEGACY_fallbackIcon={OldMentionIcon}
      {...props}
    />
  );
};

export default MentionIcon;
